import { IKeyNamePair } from "../src/taskpane/interfaces/IKeyNamePair";
import { ITenantInfo } from "../src/taskpane/interfaces/ITenantInfo";
import { boundField, dataSourceItem, SiteItem, TenantState } from "../src/taskpane/redux/models/reduxModels";
import { apiGetTenantInfo } from "../src/taskpane/services/ApiService";
import authModule from "../utilities/AuthModule";
import { logger } from "../utilities/logger";

class AdvancedSearchStateManager {
    dataSourceItems: dataSourceItem[];
    sites: SiteItem[];
    // boundedFields: boundField[];
    allowedAdvancedSearchFields: string[];
    allowedSiteCollections: string[];
    allowedTeams: string[];
    enablePII?: boolean;
    tenantEnableApprovalHooks?: boolean;
    enableRedaction?: boolean;
    isDataSourcePanelActive: boolean = false;
    replaceFileNameWithGUID?: boolean;
    disableFileRename?: boolean;
    openDocumentsInClientApp?: boolean;
    enableSharing?: boolean;
    datasourceFields?: boundField[];
    appLogo?: string;
    appColor?: string;
    enableAdvSearchMultiSites?: boolean;
    disableAdvSearchContentTypes?: boolean;

    async getTenantInfo(tenantId?: string, tenantState?: TenantState): Promise<void> {
        try {
            if (!tenantState) {
                const tenantInfo: ITenantInfo = await apiGetTenantInfo(tenantId);
                this.dataSourceItems = tenantInfo.datasources;
                this.sites = tenantInfo.sites;

                // this.boundedFields = tenantInfo.datasources
                //     ?.map(item => item.boundFields)
                //     .reduce((acc, current) => {
                //         return acc.concat(current);
                //     }, [])
                //     ?? [];

                this.allowedAdvancedSearchFields = tenantInfo.allowedAdvancedSearchFields?.toLowerCase()
                    .split(";")
                    .map(allowedField => allowedField.trim())
                    .filter(allowedField => allowedField.length > 0);

                this.allowedSiteCollections = tenantInfo.allowedSiteCollections?.toLowerCase()
                    .split(";")
                    .map(allowedSite => allowedSite.trim())
                    .filter(allowedSite => allowedSite.length > 0);

                this.allowedTeams = tenantInfo.allowedTeams?.toLowerCase()
                    .split(";")
                    .map(allowedTeam => allowedTeam.trim())
                    .filter(allowedTeam => allowedTeam.length > 0);

                this.enablePII = tenantInfo.enablePII;
                this.tenantEnableApprovalHooks = tenantInfo.tenantEnableApprovalHooks;
                this.enableRedaction = tenantInfo.enableRedaction;
                this.replaceFileNameWithGUID = tenantInfo.replaceFileNameWithGUID;
                this.disableFileRename = tenantInfo.disableFileRename;
                this.openDocumentsInClientApp = tenantInfo.openDocumentsInClientApp;
                this.enableSharing = tenantInfo.enableSharing;
                this.appColor = tenantInfo.appColor;
                this.appLogo = tenantInfo.appLogo;
                this.enableAdvSearchMultiSites = tenantInfo.enableAdvSearchMultiSites;
                this.disableAdvSearchContentTypes = tenantInfo.disableAdvSearchContentTypes;
            } else {
                this.dataSourceItems = tenantState.datasources;
                this.sites = tenantState.sites;

                // this.boundedFields = tenantState.datasources
                //     ?.map(item => item.boundFields)
                //     .reduce((acc, current) => {
                //         return acc.concat(current);
                //     }, [])
                //     ?? [];

                this.allowedAdvancedSearchFields = tenantState.allowedAdvancedSearchFields;
                this.allowedSiteCollections = tenantState.allowedSiteCollections;
                this.allowedTeams = tenantState.allowedTeams;

                this.enablePII = tenantState.enablePII;
                this.tenantEnableApprovalHooks = tenantState.tenantEnableApprovalHooks;
                this.enableRedaction = tenantState.enableRedaction;
                this.replaceFileNameWithGUID = tenantState.replaceFileNameWithGUID;
                this.disableFileRename = tenantState.disableFileRename;
                this.openDocumentsInClientApp = tenantState.openDocumentsInClientApp;
                this.enableSharing = tenantState.enableSharing;
                this.enableAdvSearchMultiSites = tenantState.enableAdvSearchMultiSites;
                this.disableAdvSearchContentTypes = tenantState.disableAdvSearchContentTypes;
            }
        } catch (error) {
            logger(error, "advancedSearchStateManager.ts (getTenantInfo)");
        }
    };

    setDatasourceFields(selectedSites: IKeyNamePair[], selectedLibraries: IKeyNamePair[]): void {
        this.datasourceFields = this.dataSourceItems
            .filter(item => this.checkDatasourceAllowed(selectedSites, selectedLibraries, item))
            .map(item => item.boundFields)
            .reduce((acc, current) => acc.concat(current), []);
    }

    private checkDatasourceAllowed(selectedSites: IKeyNamePair[], selectedLibraries: IKeyNamePair[], datasource: dataSourceItem): boolean {
        let siteAllowed: boolean = true;
        let libraryAllowed: boolean = true;

        if (datasource?.site
            && selectedSites?.length > 0
            && !datasource.site.split(";").some(site => selectedSites.some(selectedSite => selectedSite?.value?.trim() && site?.trim().toUpperCase() === selectedSite.value.trim().toUpperCase()))) {
            siteAllowed = false;
        }

        if (siteAllowed
            && datasource?.library
            && selectedLibraries?.length > 0
            && !datasource.library.split(";").some(library => selectedLibraries.some(selectedLibrary => selectedLibrary?.value?.trim() && library?.trim().toUpperCase() === selectedLibrary.value.trim().toUpperCase()))) {
            libraryAllowed = false;
        }

        if (siteAllowed && libraryAllowed) {
            if (datasource?.siteBlacklist
                && selectedSites?.length > 0
                && datasource.siteBlacklist.split(";").some(site => selectedSites.some(selectedSite => selectedSite?.value?.trim() && site?.trim().toUpperCase() === selectedSite.value.trim().toUpperCase()))) {
                siteAllowed = false;
            }

            if (siteAllowed
                && datasource?.libraryBlacklist
                && selectedLibraries?.length > 0
                && datasource.libraryBlacklist.split(";").some(library => selectedLibraries.some(selectedLibrary => selectedLibrary?.value?.trim() && library?.trim().toUpperCase() === selectedLibrary.value.trim().toUpperCase()))) {
                libraryAllowed = false;
            }
        }

        return (siteAllowed && libraryAllowed);
    }
}

const advancedSearchStateManager = new AdvancedSearchStateManager();
export default advancedSearchStateManager;